import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { ff } from '@atlassian/jira-feature-flagging';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { fireErrorAnalyticsEvents } from '@atlassian/jira-servicedesk-knowledge-common';
import {
	fetchArticleEditPermission,
	fetchArticleEditPermissionOld,
} from '@atlassian/jira-servicedesk-knowledge-services';
import { FETCH_ARTICLE_EDIT_PERMISSION } from '../../state/actions/fetch-article-edit-permission';
import { setArticleEditPermission } from '../../state/actions/set-article-edit-permission';
import { getCloudId, getProjectId } from '../../state/selectors/base';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_ARTICLE_EDIT_PERMISSION).mergeMap((action) => {
		const { id, accountId, createAnalyticsEvent, spaceKey } = action.payload;
		const cloudId = getCloudId(store.getState());
		const projectId = getProjectId(store.getState());
		return (
			ff('jira-service-desk-confluence-stargate')
				? fetchArticleEditPermission(cloudId, id, projectId, accountId, true, spaceKey)
				: fetchArticleEditPermissionOld(id, projectId, accountId, true, spaceKey)
		)
			.mergeMap(({ hasPermission }) => {
				const analyticsEvent = createAnalyticsEvent({});
				fireTrackAnalytics(analyticsEvent, 'onFetchArticleEditPermission success', {
					articleId: id,
				});
				return Observable.of(setArticleEditPermission(hasPermission, id));
			})
			.catch((error) => {
				fireErrorAnalyticsEvents(error, 'onFetchArticleEditPermission failure', PACKAGE_NAME);
				return Observable.of(setArticleEditPermission(false, id));
			});
	});
